module.exports = __webpack_public_path__ + "img/zscy@2x.6eea22eb.png";